import { ECheckPhoneStatus } from '../../../../types/phoneAuth';
import { ERequestStatus } from '../../../../types/requestStatus';
import { isValidPhone } from '../../../../utils/validation';
export function phoneSelector(state) {
  return state.phoneAuth.phone;
}
export function isAutosubmitEnabled(state) {
  return state.phoneAuth.isAutosubmitEnabled;
}
export function isPhoneAuthFormSubmitting(state) {
  var _state$phoneAuth = state.phoneAuth,
      sendValidationCode = _state$phoneAuth.sendValidationCode,
      checkPhone = _state$phoneAuth.checkPhone;
  return sendValidationCode.status === ERequestStatus.Loading || checkPhone.status === ECheckPhoneStatus.Loading;
}
export function hasPhoneErrorSelector(state) {
  var _state$phoneAuth2 = state.phoneAuth,
      sendValidationCode = _state$phoneAuth2.sendValidationCode,
      checkPhone = _state$phoneAuth2.checkPhone;
  var isSendValidationCodeError = sendValidationCode.status === ERequestStatus.Failed && !!sendValidationCode.error;
  var isCheckPhoneError = checkPhone.status === ECheckPhoneStatus.Failed && !!checkPhone.error;
  return isSendValidationCodeError || isCheckPhoneError;
}
export function phoneErrorSelector(state) {
  if (hasPhoneErrorSelector(state)) {
    return state.phoneAuth.sendValidationCode.error || state.phoneAuth.checkPhone.error;
  }

  return;
}
export function isPhoneInvalidSelector(state) {
  var phone = state.phoneAuth.phone;
  return !isValidPhone(phone);
}